import {
    GET_DASHBOARD_DATA_REQUEST,
    GET_DASHBOARD_DATA_SUCCESS,
    GET_DASHBOARD_DATA_FAILURE,
    UNLOAD_DASHBOARD,
    GET_UPTIME_REQUEST,
    GET_UPTIME_SUCCESS,
    GET_UPTIME_FAILURE,
    GET_SERVICES_STATUS_REQUEST,
    GET_SERVICES_STATUS_SUCCESS,
    GET_SERVICES_STATUS_FAILURE,
    GET_FIREWALL_POLICIES_STATUS_REQUEST,
    GET_FIREWALL_POLICIES_STATUS_SUCCESS,
    GET_FIREWALL_POLICIES_STATUS_FAILURE,
    GET_FIREWALL_SERVICES_STATUS_REQUEST,
    GET_FIREWALL_SERVICES_STATUS_SUCCESS,
    GET_FIREWALL_SERVICES_STATUS_FAILURE,
    GET_WEB_SECURITY_STATUS_REQUEST,
    GET_WEB_SECURITY_STATUS_SUCCESS,
    GET_WEB_SECURITY_STATUS_FAILURE,
    GET_PARTITIONS_STATUS_REQUEST,
    GET_PARTITIONS_STATUS_SUCCESS,
    GET_PARTITIONS_STATUS_FAILURE,
    GET_STORAGE_USAGE_REQUEST,
    GET_STORAGE_USAGE_SUCCESS,
    GET_STORAGE_USAGE_FAILURE,
    GET_ACTIVE_CALLS_REQUEST,
    GET_ACTIVE_CALLS_SUCCESS,
    GET_ACTIVE_CALLS_FAILURE,
    GET_UPDATES_REQUEST,
    GET_UPDATES_SUCCESS,
    GET_UPDATES_FAILURE,
    GET_DEVICES_UPDATES_REQUEST,
    GET_DEVICES_UPDATES_SUCCESS,
    GET_DEVICES_UPDATES_FAILURE,
    GET_WEAK_PASSWORDS_REQUEST,
    GET_WEAK_PASSWORDS_SUCCESS,
    GET_WEAK_PASSWORDS_FAILURE,
    GET_VPN_STATUS_REQUEST,
    GET_VPN_STATUS_SUCCESS,
    GET_VPN_STATUS_FAILURE,
    GET_CALLS_SUMMARY_REQUEST,
    GET_CALLS_SUMMARY_SUCCESS,
    GET_CALLS_SUMMARY_FAILURE,
    GET_TOTAL_CALLS_REQUEST,
    GET_TOTAL_CALLS_SUCCESS,
    GET_TOTAL_CALLS_FAILURE
} from '../actions/dashboardActionTypes';

const initialState = {
    isFetching: false,
    fetched: false,
    error: false,
    uptime: {
        fetching: false,
        error: false,
        now: null,
        days: null,
        hours: null,
        minutes: null
    },
    servicesStatus: {
        fetching: false,
        error: false,
        status: null
    },
    firewallPolicies: {
        fetching: false,
        error: false,
        status: null
    },
    firewallServices: {
        fetching: false,
        error: false,
        status: null
    },
    webSecurityStatus: {
        fetching: false,
        error: false,
        status: null
    },
    partitionsStatus: {
        fetching: false,
        error: false,
        status: null
    },
    storageUsage: {
        fetching: false,
        error: false,
        usage: null
    },
    activeCalls: {
        fetching: false,
        error: false,
        calls: null
    },
    updates: {
        fetching: false,
        error: false,
        qtty: null
    },
    devicesUpdates: {
        fetching: false,
        error: false,
        qtty: null
    },
    weakPasswords: {
        fetching: false,
        error: false,
        qtty: null
    },
    vpnStatus: {
        fetching: false,
        error: false,
        connected: false,
        ip: null
    },
    callsSummary: {
        fetching: false,
        error: false,
        categories: null,
        series: null
    },
    totalCalls: {
        fetching: false,
        error: false,
        value: null
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_DASHBOARD_DATA_REQUEST: {
            return {
                ...state,
                isFetching: true,
                fetched: false
            };
        }
        case GET_DASHBOARD_DATA_SUCCESS: {
            return {
                ...state,
                isFetching: false,
                fetched: true,
                error: false
            };
        }
        case GET_DASHBOARD_DATA_FAILURE: {
            return {
                ...state,
                isFetching: false,
                fetched: false,
                error: true
            };
        }
        case UNLOAD_DASHBOARD: {
            return {
                ...state,
                isFetching: false,
                fetched: false,
                error: false
            };
        }
        case GET_UPTIME_REQUEST: {
            return {
                ...state,
                uptime: {
                    ...state.uptime,
                    fetching: true
                }
            };
        }
        case GET_UPTIME_SUCCESS: {
            return {
                ...state,
                uptime: {
                    ...state.uptime,
                    fetching: false,
                    error: false,
                    now: action.payload.uptime.now,
                    days: action.payload.uptime.days,
                    hours: action.payload.uptime.hours,
                    minutes: action.payload.uptime.minutes
                }
            };
        }
        case GET_UPTIME_FAILURE: {
            return {
                ...state,
                uptime: {
                    ...state.uptime,
                    fetching: false,
                    error: true
                }
            };
        }
        case GET_SERVICES_STATUS_REQUEST: {
            return {
                ...state,
                servicesStatus: {
                    ...state.servicesStatus,
                    fetching: true
                }
            };
        }
        case GET_SERVICES_STATUS_SUCCESS: {
            return {
                ...state,
                servicesStatus: {
                    ...state.servicesStatus,
                    fetching: false,
                    error: false,
                    status: action.payload.status
                }
            };
        }
        case GET_SERVICES_STATUS_FAILURE: {
            return {
                ...state,
                servicesStatus: {
                    ...state.servicesStatus,
                    fetching: false,
                    error: true
                }
            }
        }
        case GET_FIREWALL_POLICIES_STATUS_REQUEST: {
            return {
                ...state,
                firewallPolicies: {
                    ...state.firewallPolicies,
                    fetching: true
                }
            };
        }
        case GET_FIREWALL_POLICIES_STATUS_SUCCESS: {
            return {
                ...state,
                firewallPolicies: {
                    ...state.firewallPolicies,
                    fetching: false,
                    error: false,
                    status: action.payload.status
                }
            };
        }
        case GET_FIREWALL_POLICIES_STATUS_FAILURE: {
            return {
                ...state,
                firewallPolicies: {
                    ...state.firewallPolicies,
                    fetching: false,
                    error: true
                }
            }
        }
        case GET_FIREWALL_SERVICES_STATUS_REQUEST: {
            return {
                ...state,
                firewallServices: {
                    ...state.firewallServices,
                    fetching: true
                }
            };
        }
        case GET_FIREWALL_SERVICES_STATUS_SUCCESS: {
            return {
                ...state,
                firewallServices: {
                    ...state.firewallServices,
                    fetching: false,
                    error: false,
                    status: action.payload.status
                }
            };
        }
        case GET_FIREWALL_SERVICES_STATUS_FAILURE: {
            return {
                ...state,
                firewallServices: {
                    ...state.firewallServices,
                    fetching: false,
                    error: true
                }
            }
        }
        case GET_WEB_SECURITY_STATUS_REQUEST: {
            return {
                ...state,
                webSecurityStatus: {
                    ...state.webSecurityStatus,
                    fetching: true
                }
            };
        }
        case GET_WEB_SECURITY_STATUS_SUCCESS: {
            return {
                ...state,
                webSecurityStatus: {
                    ...state.webSecurityStatus,
                    fetching: false,
                    error: false,
                    status: action.payload.status
                }
            };
        }
        case GET_WEB_SECURITY_STATUS_FAILURE: {
            return {
                ...state,
                webSecurityStatus: {
                    ...state.webSecurityStatus,
                    fetching: false,
                    error: true
                }
            }
        }
        case GET_PARTITIONS_STATUS_REQUEST: {
            return {
                ...state,
                partitionsStatus: {
                    ...state.partitionsStatus,
                    fetching: true
                }
            };
        }
        case GET_PARTITIONS_STATUS_SUCCESS: {
            return {
                ...state,
                partitionsStatus: {
                    ...state.partitionsStatus,
                    fetching: false,
                    error: false,
                    status: action.payload.status
                }
            };
        }
        case GET_PARTITIONS_STATUS_FAILURE: {
            return {
                ...state,
                partitionsStatus: {
                    ...state.partitionsStatus,
                    fetching: false,
                    error: true
                }
            };
        }
        case GET_STORAGE_USAGE_REQUEST: {
            return {
                ...state,
                storageUsage: {
                    ...state.storageUsage,
                    fetching: true
                }
            };
        }
        case GET_STORAGE_USAGE_SUCCESS: {
            return {
                ...state,
                storageUsage: {
                    ...state.storageUsage,
                    fetching: false,
                    error: false,
                    usage: action.payload.usage
                }
            };
        }
        case GET_STORAGE_USAGE_FAILURE: {
            return {
                ...state,
                storageUsage: {
                    ...state.storageUsage,
                    fetching: false,
                    error: true
                }
            };
        }
        case GET_ACTIVE_CALLS_REQUEST: {
            return {
                ...state,
                activeCalls: {
                    ...state.activeCalls,
                    fetching: true
                }
            };
        }
        case GET_ACTIVE_CALLS_SUCCESS: {
            return {
                ...state,
                activeCalls: {
                    ...state.activeCalls,
                    fetching: false,
                    error: false,
                    calls: action.payload.calls
                }
            };
        }
        case GET_ACTIVE_CALLS_FAILURE: {
            return {
                ...state,
                activeCalls: {
                    ...state.activeCalls,
                    fetching: false,
                    error: true
                }
            };
        }
        case GET_UPDATES_REQUEST: {
            return {
                ...state,
                updates: {
                    ...state.updates,
                    fetching: true,
                    qtty: null
                }
            };
        }
        case GET_UPDATES_SUCCESS: {
            return {
                ...state,
                updates: {
                    ...state.updates,
                    fetching: false,
                    error: false,
                    qtty: action.payload.updatesQtty
                }
            };
        }
        case GET_UPDATES_FAILURE: {
            return {
                ...state,
                updates: {
                    ...state.updates,
                    fetching: false,
                    error: true
                }
            };
        }
        case GET_DEVICES_UPDATES_REQUEST: {
            return {
                ...state,
                devicesUpdates: {
                    ...state.devicesUpdates,
                    fetching: true,
                    qtty: null
                }
            };
        }
        case GET_DEVICES_UPDATES_SUCCESS: {
            return {
                ...state,
                devicesUpdates: {
                    ...state.devicesUpdates,
                    fetching: false,
                    error: false,
                    qtty: action.payload.devicesUpdatesQtty
                }
            };
        }
        case GET_DEVICES_UPDATES_FAILURE: {
            return {
                ...state,
                devicesUpdates: {
                    ...state.devicesUpdates,
                    fetching: false,
                    error: true
                }
            };
        }
        case GET_WEAK_PASSWORDS_REQUEST: {
            return {
                ...state,
                weakPasswords: {
                    ...state.weakPasswords,
                    fetching: true
                }
            };
        }
        case GET_WEAK_PASSWORDS_SUCCESS: {
            return {
                ...state,
                weakPasswords: {
                    ...state.weakPasswords,
                    fetching: false,
                    error: false,
                    qtty: action.payload.weakPasswordsQtty
                }
            };
        }
        case GET_WEAK_PASSWORDS_FAILURE: {
            return {
                ...state,
                weakPasswords: {
                    ...state.weakPasswords,
                    fetching: false,
                    error: true
                }
            };
        }
        case GET_VPN_STATUS_REQUEST: {
            return {
                ...state,
                vpnStatus: {
                    ...state.vpnStatus,
                    fetching: true
                }
            };
        }
        case GET_VPN_STATUS_SUCCESS: {
            return {
                ...state,
                vpnStatus: {
                    ...state.vpnStatus,
                    fetching: false,
                    error: false,
                    connected: action.payload.vpnStatus.connected,
                    ip: action.payload.vpnStatus.ip
                }
            };
        }
        case GET_VPN_STATUS_FAILURE: {
            return {
                ...state,
                vpnStatus: {
                    ...state.vpnStatus,
                    fetching: false,
                    error: true
                }
            };
        }
        case GET_CALLS_SUMMARY_REQUEST: {
            return {
                ...state,
                callsSummary: {
                    ...state.callsSummary,
                    fetching: true
                }
            };
        }
        case GET_CALLS_SUMMARY_SUCCESS: {
            return {
                ...state,
                callsSummary: {
                    ...state.callsSummary,
                    fetching: false,
                    error: false,
                    categories: action.payload.summary.categories,
                    series: action.payload.summary.series,
                    maxSum: action.payload.summary.maxSum
                }
            };
        }
        case GET_CALLS_SUMMARY_FAILURE: {
            return {
                ...state,
                callsSummary: {
                    ...state.callsSummary,
                    fetching: false,
                    error: true
                }
            }
        }
        case GET_TOTAL_CALLS_REQUEST: {
            return {
                ...state,
                totalCalls: {
                    ...state.totalCalls,
                    fetching: true
                }
            };
        }
        case GET_TOTAL_CALLS_SUCCESS: {
            return {
                ...state,
                totalCalls: {
                    ...state.totalCalls,
                    fetching: false,
                    error: false,
                    value: action.payload.calls
                }
            };
        }
        case GET_TOTAL_CALLS_FAILURE: {
            return {
                ...state,
                totalCalls: {
                    ...state.totalCalls,
                    fetching: false,
                    error: true
                }
            };
        }
        default:
            return state;
    }
};
